import { Component, Optional, Inject, Injector, OnInit, OnDestroy, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, NG_ASYNC_VALIDATORS } from '@angular/forms';

import { InputBase } from '../../../base/input-base';

@Component({
    selector: 'aa-input-number',
    templateUrl: './input-number.component.html',
    styleUrls: [
        '../input.component.scss'
    ],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: InputNumberComponent,
            multi: true,
        }],
    standalone: false
})
export class InputNumberComponent extends InputBase<string> implements OnInit, OnDestroy
{
    private static identifier: number = 0;
    public fieldId: string = `input-number-${InputNumberComponent.identifier++}-id`;
    @Input() min: number = 0;
    @Input() max: number = 100;
    @Input() step: number = 1;

    constructor(
        @Optional() @Inject(NG_VALIDATORS) validators: Array<any>,
        @Optional() @Inject(NG_ASYNC_VALIDATORS) asyncValidators: Array<any>,
        injector: Injector
    )
    {
        super(injector);
    }

    ngOnInit ()
    {
    }

    ngOnDestroy ()
    {
    }
}
